import type { TrainingLessonSpecific } from './trainingLessonUi';

export const core4OrdinancesEs: TrainingLessonSpecific = {
  intro:
    'Las ordenanzas son actos sagrados autorizados por el sacerdocio, conectados a convenios. La preparación espiritual y la reverencia invitan al Espíritu y nos acercan a Cristo.',
  objectives: [
    'Entender qué es una ordenanza y por qué es sagrada.',
    'Diferenciar ordenanzas vs costumbres.',
    'Comprender la preparación personal (arrepentimiento, fe, dignidad).',
    'Aprender cómo prepararse para la Santa Cena como renovación de convenios.',
    'Identificar hábitos de reverencia y orden que invitan al Espíritu.',
  ],
  briefHeading: 'Ordenanzas y convenios: poder, pureza y renovación',
  briefBody:
    'Las ordenanzas requieren autoridad del sacerdocio, símbolos significativos y convenios con Dios. No son rutina: son pactos que nos acercan a Cristo y nos permiten tener Su Espíritu. La Santa Cena renueva esos convenios cada semana.',
  scriptures: [
    { ref: 'DyC 20:77, 79', text: 'Para que siempre tengan su Espíritu con ellos.' },
    { ref: '3 Nefi 18:28–29', text: 'No toméis indignamente; preparaos con reverencia.' },
    { ref: 'Moroni 4–5', text: 'La Santa Cena: recordar al Salvador y renovar convenios.' },
    { ref: 'Juan 3:5', text: 'Nacer de agua y del Espíritu.' },
    { ref: 'Mosíah 18:8–10', text: 'Estar dispuestos a llevar las cargas unos de otros.' },
  ],
  didYouKnow: [
    'Las ordenanzas unen símbolo + convenio + autoridad: no es rutina, es pacto.',
    'La reverencia no es "cara seria": es espacio para el Espíritu.',
  ],
  practiceItems: [
    'Explica en 1 frase qué es una ordenanza',
    'Antes de la Santa Cena: lista 2 cosas que harás (reverencia + enfoque)',
    'Revisa tu semana: 1 cosa a arrepentirte o ajustar (sin dramatizar, práctico)',
    'Lee DyC 20:77/79 y escribe 1 palabra clave ("recordar", "Espíritu", etc.)',
    'Llega 10 min antes el domingo y evita distracciones (teléfono/charlas)',
    'Haz 1 acto de reverencia: escuchar, servir, o ayudar a otro a prepararse',
  ],
  reflectionQuestions: [
    '¿Qué me distrae más en las ordenanzas y cómo lo corregiré?',
    '¿Qué convenio necesito recordar con más intención?',
    '¿Qué haré diferente este domingo para invitar al Espíritu?',
  ],
  actionText:
    'Santa Cena con intención: elegir 1 hábito concreto (llegar temprano, preparar escrituras, oración previa) y sostenerlo por 2 domingos seguidos.',
};
